import { gql } from '@apollo/client'

export const FIND_ALL_CHEAT_SHEET_GROUP = gql`
  query findAllCheatSheetGroup($query: CheatSheetGroupQueryInput = {}) {
    findAllCheatSheetGroup(query: $query) {
      count
      items {
        id
        title
        description
        color
        order
        icon
      }
    }
  }
`

export const CREATE_CHEAT_SHEET_GROUP = gql`
  mutation createCheatSheetGroup($createCheatSheetGroupInput: CreateCheatSheetGroupInput!) {
    createCheatSheetGroup(createCheatSheetGroupInput: $createCheatSheetGroupInput) {
      id
      title
      description
      color
      order
      icon
    }
  }
`

export const REMOVE_CHEAT_SHEET_GROUP = gql`
  mutation removeCheatSheetGroup($removeCheatSheetGroupId: String!) {
    removeCheatSheetGroup(id: $removeCheatSheetGroupId) {
      affected
    }
  }
`

export const UPDATE_CHEAT_SHEET_GROUP = gql`
  mutation updateCheatSheetGroup($updateCheatSheetGroupInputFieldName: UpdateCheatSheetGroupInput!) {
    updateCheatSheetGroup(updateCheatSheetGroupInputFieldName: $updateCheatSheetGroupInputFieldName) {
      id
    }
  }
`

export const BULK_UPDATE_CHEAT_SHEET_GROUP = gql`
  mutation bulkUpdateCheatSheetGroup($bulkUpdateCheatSheetGroupInput: [BulkUpdateCheatSheetGroupInput!]!) {
    bulkUpdateCheatSheetGroup(bulkUpdateCheatSheetGroupInput: $bulkUpdateCheatSheetGroupInput) {
      id
    }
  }
`

export const BULK_REMOVE_CHEAT_SHEET_GROUP = gql`
  mutation bulkRemoveCheatSheetGroup($ids: [LinkCheatSheetGroupInput!]!) {
    bulkRemoveCheatSheetGroup(ids: $ids) {
      affected
    }
  }
`
